import Navbar from './navbar/navbar';
import Header from './header/header';
import { useState } from 'react';
import Vision from './vision/vision';
import Team from './team/team';
import Builder from './builder/builder';
import Faq from './faq/faq';
import ProjectsList from './projectsList/ProjectsList';

function Landing({setColorFondo, colorFondo}) {
  // const [colorFondo, setColorFondo] = useState("green")
  return (
    <>
      <Navbar colorFondo={colorFondo} />
      <Header setColorFondo={setColorFondo} colorFondo={colorFondo} />
      <ProjectsList colorFondo={colorFondo}/>
      <Vision colorFondo={colorFondo} />
      <Team colorFondo={colorFondo} />
      <Builder colorFondo={colorFondo} />
      <Faq colorFondo={colorFondo}/>
    </>
  );
}

export default Landing;
